import { render } from "./LiElementUsers.vue?vue&type=template&id=241a9f9d"
import script from "./LiElementUsers.vue?vue&type=script&lang=js"
export * from "./LiElementUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__